export const environment = {
  production: true,
    API_URL: 'https://back.libracol.corefluens.co/api/',
    enterprise: "libracol",
    api_username: 'libracol',
    api_password: 'Q4d43c137W0jxea',
    enable_seas: false
};
